import React from "react";
import { Checkbox } from "antd";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";

function CheckboxField({ label, name, ...rest }) {
  return (
    <div className="mb-3">
      <Field name={name}>
        {({ field, form }) => (
          <Checkbox
            id={name}
            {...rest}
            checked={!!field.value}
            onChange={(e) => {
              form.setFieldValue(name, e.target.checked);
              form.setFieldTouched(name, true, false);
            }}
          >
            {label}
          </Checkbox>
        )}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default CheckboxField;
